/*
 *******************************************************************************
 *
 *  Filename:   /pages/system/UsersCognito/UserDetails.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   User Details Section
 *
 *  Author:     Norman J. Nolasco [ Archetact Software ]
 *
 *  Created:    Monday, May 15, 2023 - 1:18 AM (CST)
 *
 *  Notes:
 *
 *  Revisions:
 *              2023/05/15  NJN Initial Build
 *
 *  Copyright (c) 2023 - Archetact Software - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React, { useState } from "react";
import styled from "@emotion/styled";
import { spacing } from "@mui/system";
import { useNavigate } from "react-router-dom";
import {
  Avatar as MuiAvatar,
  Button as MuiButton,
  Box,
  Card as MuiCard,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";

const Button = styled(MuiButton)(spacing);
const Card = styled(MuiCard)(spacing);
const Spacer = styled.div(spacing);

const Details = ({ values, isFollowed, clickUpload, clickFollow }) => {
  const Avatar = styled(MuiAvatar)`
    display: inline-block;
    height: 64px;
    width: 64px;
    opacity: 1;
    transition: opacity 0.5s ease-in;
    position: absolute;
  `;

  const Placeholder = styled.div`
    width: 64px;
    height: 64px;
  `;
  const Centered = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
  `;

  const InitialsAvatar = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    font-size: 3.5rem;
    width: 61px;
    height: 61px;
    background-color: ${(props) => props.theme.palette.primary.light};
    color: ${(props) => props.theme.palette.primary.contrastText};
    margin: auto;
  `;

  const imageSrc = `https://www.gocampaign.com/${values.avatars3key}`;
  const hasImage = values.avatars3key ? true : false;
  const userInitials =
    (values.firstname && values.firstname[0] ? values.firstname[0] : "") +
    (values.lastname && values.lastname[0] ? values.lastname[0] : "");

  const navigate = useNavigate();

  const goMessaging = () => {
    navigate("/pages/chat");
  };

  const followColor = isFollowed ? "success" : "primary";
  const followText = isFollowed ? "Following" : "+ Follow";

  return (
    <Card mb={6} variant="outlined">
      <CardContent>
        <Grid container alignItems="center">
          <Grid item>
            {imageSrc && 1 == 0 ? (
              <>
                <Placeholder />
                <Avatar alt={values.firstname + " " + values.lastname} src={imageSrc} />
              </>
            ) : (
              <InitialsAvatar>{userInitials}</InitialsAvatar>
            )}
          </Grid>
          <Grid item xs>
            <Typography variant="body2" component="div" gutterBottom>
              <Box fontWeight="fontWeightMedium">name{values.firstname + " " + values.lastname}</Box>
              <Box fontWeight="fontWeightRegular">username{values.jobtitle}</Box>
              <Box>Active</Box>
            </Typography>
          </Grid>
        </Grid>
        <Grid container alignItems="center">
          <Grid item>
            <Box>Role1 | Role2 | Role3</Box>
            <Box>last login</Box>
            <Box>created</Box>

            <Box>follow | message</Box>
          </Grid>
        </Grid>
        {/*
          <Box>
            <Button mr={2} variant="contained" color="primary" size="small" onClick={() => clickUpload()}>
              Upload
            </Button>
            <Button mr={2} variant="contained" color={followColor} size="small" onClick={() => clickFollow()}>
              {followText}
            </Button>
            <Button mr={2} variant="contained" color="primary" size="small" onClick={() => goMessaging()}>
              Message
            </Button>
          </Box>
          */}
      </CardContent>
    </Card>
  );
};

export default Details;
